import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
declare var gtag: any;
declare var fbq: any;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor() { }

  // registra un evento en google analytics
  registerGoogleAnalyticsEvent(action: string, options: any) {
    // registra el evento en GA
    if (environment.production && !environment.test) {
      gtag('event', action, options);
    }
  }

  // registra un evento en facebook analytics
  registerFacebookEvent(event: string, options: any) {
    // registra el evento en GA
    if (environment.production && !environment.test) {
      fbq('track', event, options);
    }
  }

  // registra un evento personalizado en facebook analytics
  registerPersonalizedFacebookEvent(event: string, options: any) {
    // registra el evento en GA
    if (environment.production && !environment.test) {
      fbq('trackCustom', event, options);
    }
  }

}
